import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS } from "../lib/i18n";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "./ui/dropdown-menu";
import { Globe, CaretDown } from "@phosphor-icons/react";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = SUPPORTED_LANGS.find((l) => l.code === i18n.resolvedLanguage) || SUPPORTED_LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem("fitagenda_lang", code); }
    catch (err) { console.warn("LanguageSwitcher: cannot persist language", err?.message); }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="inline-flex items-center gap-1.5 px-2 py-1 border border-white/15 hover:border-white/40 text-[10px] uppercase tracking-[0.15em] font-bold text-zinc-300 hover:text-white transition-colors rounded-none"
        data-testid="language-switcher-trigger"
      >
        <Globe size={14} weight="bold" />
        <span>{current.short}</span>
        <CaretDown size={10} weight="bold" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#0A0A0A] border-white/15 rounded-none min-w-[140px]">
        {SUPPORTED_LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => change(l.code)}
            className={`rounded-none uppercase text-xs tracking-wider font-bold cursor-pointer ${
              l.code === current.code ? "text-[#E30613]" : "text-zinc-300"
            }`}
            data-testid={`language-option-${l.code}`}
          >
            <span className="opacity-50 mr-2">{l.short}</span>{l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
